import { Link, useLocation } from 'react-router-dom';

/**
 * Generic 404 page — shown for completely unknown routes.
 */
export default function NotFoundPage() {
  const { pathname } = useLocation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
      {/* Large muted 404 — needs dark: override because gray-200 becomes near-invisible on dark bg via CSS var inversion */}
      <div className="text-7xl font-bold text-gray-200 dark:text-gray-700 select-none mb-2">
        404
      </div>

      <h1 className="text-2xl font-bold text-gray-900 mb-2">Page not found</h1>

      <p className="text-gray-500 mb-1 max-w-md">
        The page you&apos;re looking for doesn&apos;t exist or may have been
        moved.
      </p>

      {/* bg-gray-100: light mode = #f3f4f6, dark mode CSS var inverts to #111827 (dark surface) */}
      <code className="bg-gray-100 text-gray-700 text-sm px-2 py-1 rounded font-mono mb-8">
        {pathname}
      </code>

      <div className="flex gap-4">
        <Link
          to="/"
          className="px-4 py-2 rounded-lg bg-primary text-primary-foreground hover:opacity-90 transition-opacity text-sm font-medium"
        >
          Go home
        </Link>
        <Link
          to="/"
          className="px-4 py-2 rounded-lg border border-gray-200 dark:border-outline-variant/20 text-gray-700 dark:text-on-surface hover:bg-gray-50 dark:hover:bg-surface-container transition-colors text-sm font-medium"
        >
          Browse blogs
        </Link>
      </div>
    </div>
  );
}
